export default __webpack_public_path__ + "static/media/landscaping-1.15ecafeb.webp";